import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {OrganisationService} from "../../../../services/organisation/organisation.service";
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import * as moment from "moment/moment";
import {OrgUsersService} from "../../services/org-users.service";
import {take} from "rxjs";

@Component({
  selector: 'app-org-user-filter-modal',
  templateUrl: './org-user-filter-modal.component.pug',
  styleUrls: ['./org-user-filter-modal.component.scss'],
  standalone: false
})
export class OrgUserFilterModalComponent {
    @Input() filterOptions: { label: string, value: boolean, key: string }[] = [
        {label: $localize`Owner`, value: false, key: 'owner'},
        {label:  $localize`Member`, value: false, key: 'member'},
        {label:  $localize`Xref Support`, value: false, key: 'support'}
    ];
    @Input() org: any;
    @Input() searchQuery = {type: '', search: ''};
    @Input() rowsPerView: number = 20;
    @Input() currentPage: number = 1;
    @Input() sortString: string = 'last_access';
    @Input() sortOrder: string = 'desc';
    filters: any[] = [];
    orgUsers: any;
    total: number = 0;
    applyFilter = new EventEmitter();
    @Input() filterTitle = $localize`User role`;

    constructor(
        public modalRef: BsModalRef,
        private organisationService: OrganisationService,
        private permissions: PermissionsService,
        private alertList: AlertBannerService,
        public orgUserService: OrgUsersService
    ) {
    }


  ngOnInit() {
    this.getSharedData()
  }

  getSharedData() {
    this.orgUserService.currentData.subscribe(data => {
      if (data.filters) {
        this.filters = data.filters;
        this.filterOptions.forEach(role => {
          role.value = this.filters.includes(role.key);
        });
      }
    });
  }

  updateSharedData() {
    const data = {
      searchedData: this.searchQuery,
      rowsPerView: this.rowsPerView,
      currentPage: this.currentPage,
      sortString: this.sortString,
      sortOrder: this.sortOrder,
      filters: this.filters
    };
    this.orgUserService.updateData(data);
  }

    onToggle(role: { label: string, value: boolean }): void {
        const index = this.filterOptions.findIndex(r => r.label === role.label);
        if (index !== -1) {
            this.filterOptions[index].value = !this.filterOptions[index].value;
        }
    }

    resetFilters(): void {
        this.filterOptions.forEach(role => role.value = false);
    }

    applyFilters(): void {

      this.filters = this.filterOptions.filter(role => role.value).map(role => role.key)
      this.applyFilter.emit(this.filters);
      this.updateSharedData()
      this.modalRef?.hide();
    }

}
